import React, { Component } from "react";
import { ErrorNotification, MnemoLoading, Title } from "components/misc";
import { MInput, MSelect } from "components/forms";
import { Button, Row, Col, Icon } from "design-react-kit";
import { adminService, mySleep, stringHelper } from "libs";
import { CM30_EDITION, IUL30_EDITION, RC30_EDITION, RCALL_EDITION, UM30_EDITION, UNT30_EDITION } from "const";

export class LessonLiveScheduleProcess extends Component {
  state = {
    loading: false,
    loadingError: "",
    city: "",
    idExamSession: 0,
    academicYear: 0,
    students: [],
    studentPayments: {},
  };

  PAYLOAD_YEAR = {
    options: [
      { label: "SELEZIONA UN ANNO ACCADEMICO", value: 0 },
      { label: "2023/2024", value: 2023 },
      { label: "2024/2025", value: 2024 },
      { label: "2025/2026", value: 2025 },
    ],
  };

  PAYLOAD_EXAMSESSION = {
    2023: {
      options: [
        { label: "SELEZIONA UNA EDIZIONE", value: 0 },

        { label: "REGGIO - PRIMA", value: RC30_EDITION.first },
        { label: "REGGIO - SECONDA", value: RC30_EDITION.second },
        { label: "REGGIO - TERZA", value: RC30_EDITION.third },
        { label: "REGGIO - QUARTA", value: RC30_EDITION.fourth },
        { label: "UNICAMILLUS - SECONDA", value: UM30_EDITION.second },
        { label: "TCHAIKOVSKY - SECONDA", value: CM30_EDITION.second },
        { label: "60CFU ALL1", value: RCALL_EDITION.first_rc60 },
        { label: "30CFU ALL2", value: RCALL_EDITION.first_rc30 },
      ],
    },
    2024: {
      options: [
        { label: "SELEZIONA UNA EDIZIONE", value: 0 },
        { label: "REGGIO  - TERZA", value: RC30_EDITION.third_2024 },
        { label: "UNICAMILLUS - TERZA", value: UM30_EDITION.third_2024 },
        { label: "TCHAIKOVSKY - TERZA", value: CM30_EDITION.third_2024 },
        { label: "UNITELMA - TERZA", value: UNT30_EDITION.third_2024 },
        { label: "--------------------", value: 0 },
        { label: "REGGIO - SECONDA", value: RC30_EDITION.second_2024 },
        { label: "UNICAMILLUS - SECONDA", value: UM30_EDITION.second_2024 },
        { label: "TCHAIKOVSKY - SECONDA", value: CM30_EDITION.second_2024 },
        { label: "IUL - SECONDA", value: IUL30_EDITION.second_2024 },
        { label: "-------", value: 0 },
        { label: "REGGIO - PRIMA", value: RC30_EDITION.first_2024 },
        { label: "UNICAMILLUS - PRIMA", value: UM30_EDITION.first_2024 },
        { label: "TCHAIKOVSKY - PRIMA", value: CM30_EDITION.first_2024 },
      ],
    },
    2025: {
      options: [
        { label: "SELEZIONA UNA EDIZIONE", value: 0 },
        { label: "REGGIO - PRIMA", value: RC30_EDITION.first_2025 },
        { label: "UNICAMILLUS - PRIMA", value: UM30_EDITION.first_2025 },
        { label: "TCHAIKOVSKY - PRIMA", value: CM30_EDITION.first_2025 },
        { label: "UNITELMA - PRIMA", value: UNT30_EDITION.first_2025 },
        { label: "-------", value: 0 },
        { label: "REGGIO - SECONDA", value: RC30_EDITION.second_2025 },
        { label: "UNICAMILLUS - SECONDA", value: UM30_EDITION.second_2025 },
        { label: "TCHAIKOVSKY - SECONDA", value: CM30_EDITION.second_2025 },
        { label: "UNITELMA - SECONDA", value: UNT30_EDITION.second_2025 },
        { label: "-------", value: 0 },
        { label: "REGGIO - TERZA", value: RC30_EDITION.third_2025 },
        { label: "UNICAMILLUS - TERZA", value: UM30_EDITION.third_2025 },
        { label: "TCHAIKOVSKY - TERZA", value: CM30_EDITION.third_2025 },
        { label: "UNITELMA - TERZA", value: UNT30_EDITION.third_2025 },
      ],
    },
  };

  setAcademicYear = (_, value) => {
    const idExamSession = 0;
    this.setState({ academicYear: value, idExamSession });
  };

  setIdExamSession = (_, value) => {
    this.setState({ idExamSession: value });
  };

  setCity = (_, value) => {
    this.setState({ city: value });
  };

  loadStudents = () => {
    this.setState({ loading: true, loadingError: "", studentPayments: {} });
    const { city, idExamSession, academicYear } = this.state;

    if (idExamSession === 0) {
      ErrorNotification.render("Devi specificare un edizione per poter procedere");
      this.setState({ loading: false });
    } else if (city.length === 0) {
      ErrorNotification.render("Devi inserire la città esami per poter procedere. Se vuoi tutte le citta scrivi 'TUTTE'");
      this.setState({ loading: false });
    } else {
      adminService
        .listStudents(city, idExamSession, academicYear)
        .then(({ data }) => {
          this.setState({ students: data.payload.students, loading: false });
        })
        .catch((error) => {
          console.error("Error ", error);
          ErrorNotification.render("Errore  server");
          this.setState({ loading: false, loadingError: error });
        });
    }
  };

  analyzeStudents = (e) => {
    //for the second click exit
    e.preventDefault();
    if (e.detail > 1) {
      return;
    }

    this.setState({ loading: true, loadingError: "" });
    const { students, city, idExamSession, academicYear } = this.state;

    if (students.length === 0) {
      ErrorNotification.render("Nessuno studente da analizzare");
      this.setState({ loading: false });
    } else {
      if (idExamSession === 0 || city.length === 0 || academicYear === 0) {
        ErrorNotification.render("Dati inconsistenti. Ricarica l'elenco degli studenti tramite il pulsante 'Elenco studenti'");
        this.setState({ loading: false });
      } else {
        adminService
          .lessonLiveAnalytics(city, idExamSession, academicYear)
          .then(({ data }) => {
            this.loadStudents();
            this.setState({ loading: false });
          })
          .catch((error) => {
            console.error("Error ", error);
            ErrorNotification.render("Errore  server");
            this.setState({ loading: false, loadingError: error });
          });
      }
    }
  };

  analyzeStudent = (student) => {
    this.setState({ loading: true, loadingError: "" });
    const { academicYear } = this.state;

    adminService
      .lessonLiveAnalyticStudent(student.registrationCode, academicYear)
      .then(({ data }) => {
        this.loadStudents();
        this.setState({ loading: false });
      })
      .catch((error) => {
        console.error("Error ", error);
        ErrorNotification.render("Errore  server");
        this.setState({ loading: false, loadingError: error });
      });
  };

  analyzeStudent40 = (student) => {
    this.setState({ loading: true, loadingError: "" });
    const { academicYear } = this.state;

    adminService
      .lessonLiveAnalyticStudent(student.registrationCode, academicYear, true)
      .then(({ data }) => {
        this.loadStudents();
        this.setState({ loading: false });
      })
      .catch((error) => {
        console.error("Error ", error);
        ErrorNotification.render("Errore  server");
        this.setState({ loading: false, loadingError: error });
      });
  };

  verifyPaymentStudents = async (e) => {
    //for the second click exit
    e.preventDefault();
    if (e.detail > 1) {
      return;
    }

    this.setState({ loading: true, loadingError: "", studentPayments: {} });
    const { students } = this.state;

    if (students.length === 0) {
      ErrorNotification.render("Nessuno studente da analizzare");
      this.setState({ loading: false });
    } else {
      // create an array with students with percent <0.7
      const toSkip = students.filter((student) => student.percent < 0.7);

      let processed = {};

      for (let i = 0; i < students.length; i++) {
        const student = students[i];
        const rCode = student.registrationCode;

        if (processed[rCode]) continue;

        const skip = toSkip.find((s) => s.registrationCode === rCode);

        if (!skip) {
          processed[rCode] = "invio in corso";

           await mySleep(500); 
           
          this.verifyPayment(student);
        } else {
          
           this.setState((prevState) => ({
            studentPayments: {
              ...prevState.studentPayments,
              [rCode]: "Percentuale non raggiunta. Pagamento non generato.",
            }
          }));
        }

       //console.log(`Processed ${i + 1} of ${students.length}`);break;
       
      }

      this.setState({ loading: false });
    }
  };

  verifyPayment = (student) => {
    const rCode = student.registrationCode;

    this.setState((prevState) => ({
      studentPayments: {
        ...prevState.studentPayments,
        [rCode]: "invio in corso",
      },
    }));

    adminService
      .verifyPayment(rCode)
      .then(({ data }) => {
        if (data.payload.operation) {
          this.setState((prevState) => ({
            studentPayments: {
              ...prevState.studentPayments,
              [rCode]: data.payload.operation,
            },
          }));
        }
      })
      .catch((error) => {
        console.error("Error", error);
        ErrorNotification.render("Errore server");
        this.setState((prevState) => ({
          studentPayments: {
            ...prevState.studentPayments,
            [rCode]: "Errore durante la verifica",
          },
        }));
      });
  };

  /** calc percentage */
  calcPercentage = (percentage) => {
    return percentage ? percentage.toString().replace(".", ",") : "0";
  }; //calcPercentage

  exportStudents = () => {
    const { students, city } = this.state;
    if (students.length === 0) {
      ErrorNotification.render("Nessuno studente da analizzare");
      this.setState({ loading: false });
    } else {
      //let str = "CODICE REGISTRAZIONE;COGNOME;NOME;EMAIL;TELEFONO;CODICE CORSO;FASE;MINUTI COLLEGAMENTO;PERCENTUALE\r\n";
      let str =
        "CODICE REGISTRAZIONE;COGNOME;NOME;EMAIL;TELEFONO;CODICE CORSO;MINUTI COLLEGAMENTO FASE 1;PERCENTUALE FASE 1;LIMITE NON RAGGIUNTO  FASE 1;MINUTI COLLEGAMENTO FASE 2;PERCENTUALE FASE 2;LIMITE NON RAGGIUNTO FASE 2;SEDE;CLASSE_CONCORSO\r\n";

      let previousRegistrationCode = null;

      for (let i = 0; i < students.length; i++) {
        // controlla registrationCode precedente se uguale salto al prossimo indice
        if (students[i].registrationCode === previousRegistrationCode) {
          continue;
        }

        previousRegistrationCode = students[i].registrationCode;

        let minutiCollegamantoFase1 = 0;
        let minutiCollegamantoFase2 = 0;
        let percentFase1 = 0;
        let percentFase2 = 0;
        let limiteNonRaggiuntoFase1 = "";
        let limiteNonRaggiuntoFase2 = "";

        minutiCollegamantoFase1 = stringHelper.formatNumber(students[i].minutes);
        percentFase1 = this.calcPercentage(stringHelper.formatPercentage(students[i].percent));

        if (students[i].percent < 0.7) {
          limiteNonRaggiuntoFase1 = "LIMITE NON RAGGIUNTO";
        }

        // Cerca la riga successiva con lo stesso registrationCode (cioè seconda "fase")
        if (i + 1 < students.length && students[i + 1].registrationCode === students[i].registrationCode) {
          minutiCollegamantoFase2 = stringHelper.formatNumber(students[i + 1].minutes);
          percentFase2 = this.calcPercentage(stringHelper.formatPercentage(students[i + 1].percent));
          if (students[i + 1].percent < 0.7) {
            limiteNonRaggiuntoFase2 = "LIMITE NON RAGGIUNTO";
          }
        }

        let addRow = `${students[i].registrationCode};${students[i].surname};${students[i].name};${students[i].email};${students[i].mobile};${students[i].courseCode};${minutiCollegamantoFase1};${percentFase1};${limiteNonRaggiuntoFase1};${minutiCollegamantoFase2};${percentFase2};${limiteNonRaggiuntoFase2};${students[i].examSite};${students[i].competitionclass}`;
        str += addRow + "\r\n";
      }

      // calcolo il nome della edizione selezionata
      const selectedEdition = this.PAYLOAD_EXAMSESSION[this.state.academicYear].options.find(
        (option) => option.value === parseInt(this.state.idExamSession),
      );
      const editionLabel = selectedEdition ? selectedEdition.label : "";

      let downloadLink = document.createElement("a");
      downloadLink.href = "data:text/csv;charset=utf-8," + encodeURIComponent(str);
      downloadLink.download = "corsisti_esami_" + this.state.academicYear + "_" + editionLabel + "_" + city + ".csv";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  };

  renderTableBody = (academicYear, students, studentPayments) => {
    const aa = parseInt(academicYear);

    if (aa === 2024) {
      return students.map((student, index) => {
        const show = index % 2 === 0;
        return (
          <tr key={index}>
            {show ? (
              <>
                <td>{Math.ceil((index + 1) / 2)}</td>
                <td>{student.registrationCode}</td>
                <td>{student.surname}</td>
                <td>{student.name}</td>
                <td>{student.email}</td>
                <td>{student.mobile}</td>
                <td>{student.competitionclass}</td>
                <td>{student.examSite}</td>
              </>
            ) : (
              <>
                <td colSpan={8}>
                  <p className="action icon-link" onClick={(e) => this.analyzeStudent(student)}>
                    Ricalcola Tempo (6 ore)
                    <Icon color="primary" icon="it-chart-line" />
                  </p>
                  <p className="action icon-link" onClick={(e) => this.analyzeStudent40(student)}>
                    Ricalcola tempo (4 ore)
                    <Icon color="primary" icon="it-chart-line" />
                  </p>
                  {studentPayments && studentPayments.hasOwnProperty(student.registrationCode) && <>{studentPayments[student.registrationCode]}</>}
                </td>
              </>
            )}

            <td>
              {stringHelper.formatNumber(student.minutes)}
              <br />
              <span>FASE {student.stage}</span>
            </td>
            <td>
              {stringHelper.formatPercentage(student.percent)} {student.percent < 0.7 && <span className="text-red">LIMITE NON RAGGIUNTO</span>}
            </td>
          </tr>
        );
      });
    } else {
      return students.map((student, index) => {
        return (
          <tr key={index}>
            <td>
              {index + 1}
              <div className="mt-2 d-flex">
                <span className="action icon-link" title="Ricalcola Tempo" onClick={() => this.analyzeStudent(student)}>
                  <Icon icon="it-chart-line" color="primary" />
                </span>

                <span className="action icon-link ml-2" title="Verifica pagamento aggiuntivo" onClick={() => this.verifyPayment(student)}>
                  <Icon icon="it-file" color="primary" />
                </span>
              </div>
            </td>
            <td>
              {studentPayments && studentPayments.hasOwnProperty(student.registrationCode) ? <>{studentPayments[student.registrationCode]}</> : <></>}
            </td>
            <td>{student.registrationCode}</td>
            <td>{student.surname}</td>
            <td>{student.name}</td>
            <td>{student.email}</td>
            <td>{student.mobile}</td>
            <td>{student.competitionclass}</td>
            <td>{student.examSite}</td>
            <td>{stringHelper.formatNumber(student.minutes)}</td>
            <td>
              {stringHelper.formatPercentage(student.percent)} {student.percent < 0.7 && <span className="text-red">LIMITE NON RAGGIUNTO</span>}
            </td>
          </tr>
        );
      });
    }
  }; // renderTableBody

  render() {
    const { city, loading, students, studentPayments, academicYear } = this.state;

    // per gli anni 2023/2024 e 2025/2026 abbiamo una statistica unica,
    // invece per il 2024 abbiamo una statistica differente per pgni fase delle lezioni

    const isSingleRow = [2023, 2025, 2026].includes(parseInt(academicYear));

    return (
      <>
        {loading && <MnemoLoading />}
        <section className="m-4">
          <Title>Analisi frequenza ex art. 13</Title>
          <Row>
            <Col md={12}>
              <MSelect onChange={this.setAcademicYear} id="academicYear" payload={this.PAYLOAD_YEAR}></MSelect>
            </Col>
          </Row>
          {academicYear > 0 && (
            <>
              <Row>
                <Col md={6}>
                  <MSelect onChange={this.setIdExamSession} id="idExamSession" payload={this.PAYLOAD_EXAMSESSION[academicYear]}></MSelect>
                </Col>
                <Col md={6}>
                  <MInput
                    id="mcity"
                    value={city}
                    label="Inserisci la città esami"
                    onChange={this.setCity}
                    infoText="Se vuoi tutte le citta scrivi 'TUTTE'"
                  ></MInput>
                </Col>
              </Row>
            </>
          )}
          <Button
            color="primary bg-dark"
            onClick={() => {
              this.loadStudents();
            }}
          >
            <span className="d-button-label">Elenco studenti</span>
          </Button>
          <Button
            className="ml-2"
            color="primary"
            outline
            onClick={(e) => {
              this.analyzeStudents(e);
            }}
          >
            <span className="d-button-label">Calcola tempo presenza</span>
          </Button>
          {
            <Button
              className="ml-2"
              color="primary"
              outline
              onClick={(e) => {
                this.verifyPaymentStudents(e);
              }}
            >
              <span className="d-button-label">Verifica pagamenti aggiuntivi</span>
            </Button>
          }
          <Button
            className="ml-2"
            color="primary"
            outline
            onClick={() => {
              this.exportStudents();
            }}
          >
            <span className="d-button-label">Esporta</span>
          </Button>
          <hr />

          {students.length > 0 && (
            <>
              <h5>Studenti trovati {isSingleRow ? students.length : students.length / 2.0}</h5>
              <table className="MTable table  table-striped table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    {isSingleRow ? <th></th> : <></>}
                    <th>Codice registrazione</th>
                    <th>Cognome</th>
                    <th>Nome</th>
                    <th>Email</th>
                    <th>Telefono</th>
                    <th>Classe di concorso</th>
                    <th>Sede esami</th>
                    <th>Minuti collegamento</th>
                    <th>Frequenza di collegamento</th>
                  </tr>
                </thead>
                <tbody>{this.renderTableBody(academicYear, students, studentPayments)}</tbody>
              </table>
            </>
          )}
        </section>
      </>
    );
  }
}
